import {GlobalStyles} from '@mui/material';
import React from 'react';

const styles = theme => ({
  '#root': {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    backgroundColor: '#fff', //theme.palette.background.default,
    height: '100%',
    padding: '0 !important',
  },
  html: {
    width: '100%',
    height: '100%',
  },
  // style for shift-drag-zoom
  '.ol-box': {
    border: `1px dashed ${theme.palette.grey[500]}`,
    background: theme.palette.grey[100],
    opacity: 0.4,
  },
});

const appGlobalStyles = <GlobalStyles styles={styles} />;

export default appGlobalStyles;
